import reducer from './distribution.reducer';
import * as action from './distribution.action';
import * as selector from './distribution.selector';
import * as constant from './distribution.constant';
import initialState from './distribution.initialState';
import saga from './distribution.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  saga,
  name: constant.NAME,
};
